import { memo } from 'react';

import { TextField } from 'components';
import { getCustomOrderNumberState } from '../../customOrderNumber.utils';

const { Input } = TextField;

const StringField = memo(
	({ title, value, onChange, config, values, disabled }) => {
		const customOrderNumber = getCustomOrderNumberState(config, values);
		const prefix = customOrderNumber?.prefix;
		const prefixIncluded =
			prefix && typeof value === 'string' && value.trim().startsWith(prefix);

		return (
			<Input
				width='100%'
				placeholder={title}
				value={customOrderNumber ? (value ?? '') : value}
				// Ant Design remounts the focused input if the addon is removed.
				addonBefore={
					customOrderNumber ? (
						<span>{prefix && !prefixIncluded ? prefix : null}</span>
					) : undefined
				}
				disabled={customOrderNumber ? disabled || !prefix : undefined}
				onChange={e => onChange(e.target.value)}
			/>
		);
	},
);

export default StringField;
